/* Wristory: reveal, rails, gallery, sticky header. Safe to load more than once. */
(function () {
  if (window.__wristoryInit) return;
  window.__wristoryInit = true;

  function reveal() {
    var els = document.querySelectorAll('.wr-rev:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  function rails() {
    document.querySelectorAll('[data-wr-rail]').forEach(function (root) {
      if (root.dataset.wrBound) return;
      root.dataset.wrBound = '1';
      var track = root.querySelector('.wr-track');
      if (!track) return;
      root.querySelectorAll('[data-wr-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.querySelector('.wr-card');
          var step = card ? card.getBoundingClientRect().width + 16 : 280;
          track.scrollBy({ left: (btn.dataset.wrDir === 'next' ? 1 : -1) * step * 2, behavior: 'smooth' });
        });
      });
    });
  }

  function gallery() {
    document.querySelectorAll('[data-wr-gal]').forEach(function (root) {
      if (root.dataset.wrBound) return;
      root.dataset.wrBound = '1';
      var main = root.querySelector('[data-wr-main]');
      if (!main) return;
      root.querySelectorAll('[data-wr-th]').forEach(function (th) {
        th.addEventListener('click', function () {
          var src = th.dataset.wrTh;
          if (!src) return;
          main.src = src;
          main.removeAttribute('srcset');
          root.querySelectorAll('[data-wr-th]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
          th.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function stickyHeader() {
    var h = document.querySelector('#header-component');
    if (!h || h.dataset.wrStickBound) return;
    h.dataset.wrStickBound = '1';
    var onScroll = function () {
      if (window.scrollY > 12) { h.setAttribute('data-wr-stuck', ''); }
      else { h.removeAttribute('data-wr-stuck'); }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function boot() { reveal(); rails(); gallery(); stickyHeader(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
